import React, { useState } from "react";
import Axios from "../../services/AxiosInstance";

const CreateJob = () => {

  const [formData, setFormData] = useState({
    companyName: "",
    techStack: "",
    jobDescription: "",
    minSalary: "",
    maxSalary: "",
    timeline: "",
    expiryDate: "",
    experience: "",
    customExperience: ""
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    setErrors({ ...errors, [name]: "" });
  };

  //  VALIDATION
  const validate = () => {
    let newErrors = {};

    if (!formData.companyName.trim()) newErrors.companyName = "Company Name is required";
    if (!formData.techStack.trim()) newErrors.techStack = "Tech Stack is required";
    if (!formData.jobDescription.trim()) newErrors.jobDescription = "Description is required";
    if (!formData.minSalary) newErrors.minSalary = "Minimum Salary is required";
    if (!formData.maxSalary) newErrors.maxSalary = "Maximum Salary is required";
    if (!formData.timeline.trim()) newErrors.timeline = "Timeline is required";
    if (!formData.expiryDate) {
      newErrors.expiryDate = "Expiry date is required";
    } else {
      const picked = new Date(formData.expiryDate + "T23:59:59");
      if (Number.isNaN(picked.getTime())) newErrors.expiryDate = "Invalid expiry date";
      else if (picked <= new Date()) newErrors.expiryDate = "Expiry date must be in the future";
    }

    if (!formData.experience) newErrors.experience = "Experience is required";
    if (formData.experience === "other" && !formData.customExperience.trim()) {
      newErrors.experience = "Please enter custom experience";
    }

    if (
      formData.minSalary &&
      formData.maxSalary &&
      Number(formData.minSalary) > Number(formData.maxSalary)
    ) {
      newErrors.maxSalary = "Max salary must be greater than min salary";
    }

    return newErrors;
  };

  //  SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await Axios.post(
        `/api/jobs`,
        {
          companyName: formData.companyName,
          techStack: formData.techStack,
          jobDescription: formData.jobDescription,
          minSalary: formData.minSalary,
          maxSalary: formData.maxSalary,
          timeline: formData.timeline,
          expiryDate: formData.expiryDate,
          experience:
            formData.experience === "other"
              ? formData.customExperience
              : formData.experience
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("SUCCESS:", response.data);

      alert(`🎉 Job Created Successfully\nJob ID: ${response.data.jobId}`);

      //  RESET FORM
      setFormData({
        companyName: "",
        techStack: "",
        jobDescription: "",
        minSalary: "",
        maxSalary: "",
        timeline: "",
        expiryDate: "",
        experience: "",
        customExperience: ""
      });

    } catch (error) {
      console.log("FULL ERROR:", error);

      alert(
        error.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    }
  };

  return (
    <div style={{ marginLeft: "400px", marginTop: "5px", padding: "10px", minHeight: "80vh" }}>

      <div className="job-card">

        <h3 className="job-title">CREATE JOB</h3>

        <form onSubmit={handleSubmit}>

          {/* Company Name */}
          <div className="form-group">
            <label>Company Name</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              className={errors.companyName ? "error-input" : ""}
            />
            {errors.companyName && <small className="error-text">{errors.companyName}</small>}
          </div>

          {/* Tech Stack */}
          <div className="form-group">
            <label>Tech Stack</label>
            <input
              type="text"
              name="techStack"
              value={formData.techStack}
              onChange={handleChange}
              className={errors.techStack ? "error-input" : ""}
            />
            {errors.techStack && <small className="error-text">{errors.techStack}</small>}
          </div>

          {/* Description */}
          <div className="form-group">
            <label>Job Description</label>
            <textarea
              name="jobDescription"
              rows="6"
              value={formData.jobDescription}
              onChange={handleChange}
              className={errors.jobDescription ? "error-input" : ""}
            />
            {errors.jobDescription && <small className="error-text">{errors.jobDescription}</small>}
          </div>

          {/* Min Salary */}
          <div className="form-group">
            <label>Minimum Salary (Rs.)</label>
            <input
              type="number"
              name="minSalary"
              value={formData.minSalary}
              onChange={handleChange}
              className={errors.minSalary ? "error-input" : ""}
            />
            {errors.minSalary && <small className="error-text">{errors.minSalary}</small>}
          </div>

          {/* Max Salary */}
          <div className="form-group">
            <label>Maximum Salary (Rs.)</label>
            <input
              type="number"
              name="maxSalary"
              value={formData.maxSalary}
              onChange={handleChange}
              className={errors.maxSalary ? "error-input" : ""}
            />
            {errors.maxSalary && <small className="error-text">{errors.maxSalary}</small>}
          </div>

          {/* Timeline */}
          <div className="form-group">
            <label>Hiring Timeline</label>
            <input
              type="text"
              name="timeline"
              value={formData.timeline}
              onChange={handleChange}
              className={errors.timeline ? "error-input" : ""}
            />
            {errors.timeline && <small className="error-text">{errors.timeline}</small>}
          </div>

          {/* Expiry */}
          <div className="form-group">
            <label>Last Date to Apply</label>
            <input
              type="date"
              name="expiryDate"
              value={formData.expiryDate}
              onChange={handleChange}
              min={new Date().toISOString().slice(0, 10)}
              className={errors.expiryDate ? "error-input" : ""}
            />
            {errors.expiryDate && <small className="error-text">{errors.expiryDate}</small>}
          </div>

          {/* Experience */}
          <div className="form-group">
            <label>Experience</label>

            <select
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              className={errors.experience ? "error-input" : ""}
            >
              <option value="">Select Experience</option>
              <option value="1 year">1 Year</option>
              <option value="2 years">2 Years</option>
              <option value="3 years">3 Years</option>
              <option value="4 years">4 Years</option>
              <option value="5 years">5 Years</option>
              <option value="6+ years">6+ Years</option>
              <option value="other">Other</option>
            </select>

            {formData.experience === "other" && (
              <input
                type="text"
                name="customExperience"
                placeholder="Enter experience (e.g. 7 years)"
                value={formData.customExperience}
                onChange={handleChange}
                style={{ marginTop: "10px" }}
              />
            )}

            {errors.experience && (
              <small className="error-text">{errors.experience}</small>
            )}
          </div>

          <center>
            <button className="submit-btn">
              Submit Job
            </button>
          </center>

        </form>

      </div>
    </div>
  );
};

export default CreateJob;